import * as React from 'react';

export const PortalContext = React.createContext([]);
PortalContext.displayName = 'PortalContext';

export const portalSelector = 'data-react-universal-portal';
